import {
  UserAvailabilityStatus,
  UserSetAvailabilityStatus,
} from '@api/generated/graphql';
import { tokens } from '@servicetitan/tokens/core';

export const statusValues = {
  [UserSetAvailabilityStatus.Available]: 'Available',
  [UserSetAvailabilityStatus.ExtendedWrapUp]: 'Extended Wrap Up',
  [UserSetAvailabilityStatus.Break]: 'Break',
  [UserSetAvailabilityStatus.AwayFromDesk]: 'Away From Desk',
  [UserSetAvailabilityStatus.Unavailable]: 'Unavailable',
  [UserSetAvailabilityStatus.Offline]: 'Offline',
  [UserAvailabilityStatus.WrapUp]: 'Wrap Up', // to include automated queue wrap up status (aka Recovery)
};

export const StatusDotColor: Record<string, string> = {
  [UserAvailabilityStatus.Available]: `${tokens.colorGreen500}`,
  [UserAvailabilityStatus.AwayFromDesk]: `${tokens.colorOrange400}`,
  [UserAvailabilityStatus.Break]: `${tokens.colorPurple400}`,
  [UserAvailabilityStatus.Offline]: `${tokens.colorBlueGrey600}`,
  [UserAvailabilityStatus.WrapUp]: `${tokens.colorCyan600}`,
  [UserAvailabilityStatus.ExtendedWrapUp]: `${tokens.colorCyan600}`,
  [UserAvailabilityStatus.Unavailable]: `${tokens.colorRed500}`,
};

export const StatusBackgroundColor: Record<string, string> = {
  [UserAvailabilityStatus.Available]: `${tokens.colorGreen100}`,
  [UserAvailabilityStatus.AwayFromDesk]: `${tokens.colorOrange100}`,
  [UserAvailabilityStatus.Break]: `${tokens.colorPurple100}`,
  [UserAvailabilityStatus.Offline]: `${tokens.colorBlueGrey100}`,
  [UserAvailabilityStatus.WrapUp]: `${tokens.colorCyan100}`,
  [UserAvailabilityStatus.ExtendedWrapUp]: `${tokens.colorCyan100}`,
  [UserAvailabilityStatus.Unavailable]: `${tokens.colorRed100}`,
};

export default statusValues;
